import * as ActionTypes from './actions';
import * as StripeActionTypes from './Stripe/actions';
import update from 'immutability-helper';
import { processErrorResponse } from '../../../common/middleware/api';

const paymentProcessors = (state = {}, action) => {
	switch (action.type) {
		case ActionTypes.INIT_PAYMENT_METHOD:
			const currentPaymentMethodState = state[action.payload.paymentMethodName];
			if (!currentPaymentMethodState) {
				return update(state, {
					[action.payload.paymentMethodName]: { $set: action.payload.paymentMethodData }
				});
			}

			return update(state, {
				[action.payload.paymentMethodName]: { $merge: action.payload.paymentMethodData }
			});
		case StripeActionTypes.STRIPE_CARD_UPDATE_START:
			const paymentId = action.payload.paymentId;
			return updateStripeCardUpdateError(state, paymentId, null);
		case StripeActionTypes.STRIPE_CARD_UPDATE_FAILED:
			const failedPaymentId = action.paymentId;
			let errorMessage = action.message;

			if (action.errorResponse) {
				const apiErrors = processErrorResponse(action.errorResponse);
				errorMessage = apiErrors.message;
			}

			return updateStripeCardUpdateError(state, failedPaymentId, errorMessage);
		default:
			return state;
	}
};

const updateStripeCardUpdateError = (state, paymentId, errorMessage) => {
	const newData = { payments: { [paymentId]: { paymentOptionUpdateError: errorMessage } } };

	const stripeState = state['Stripe'];
	if (!stripeState) {
		return update(state, {
			['Stripe']: { $set: newData }
		});
	}
	return update(state, {
		['Stripe']: { $merge: newData }
	});
}

export default paymentProcessors;